import { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

const EndVideoCall: React.FC = () => {
    const location = useLocation<{ docName: string }>();

    if (!location.state.docName) {
        return null;
    }

    return (
        <Fragment>
            <Helmet>
                <meta charSet="utf-8" />
                <title>EKA - Teleconsultation</title>
            </Helmet>
            <div className="flex flex-col h-full font-grotesk bg-neutral-black items-center justify-center text-center text-white">
                <div className="flex-1 flex items-center flex-col justify-center text-center text-white">
                    <p>Your call with</p>
                    <p className="font-700">{location.state.docName}</p>
                    <p>has ended.</p>
                    <p className="mt-16">You may close this page now.</p>
                </div>
            </div>
        </Fragment>
    );
};
export default EndVideoCall;
